import { DeploymentsApi, DeploymentsApiOptions } from './DeploymentsApi';
import { Deployment } from '../types';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { ResponseError } from '@backstage/errors';
import crossFetch from 'cross-fetch';

// these are isomorphic types that don't require @backstage/core-plugin-api
type DiscoveryApi = { getBaseUrl(pluginId: string): Promise<string> };
type FetchApi = { fetch: typeof fetch };

export class DeploymentsClient implements DeploymentsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  public constructor(deps: {
    discoveryApi: DiscoveryApi;
    fetchApi?: FetchApi;
  }) {
    const { discoveryApi, fetchApi } = deps;
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi ?? { fetch: crossFetch };
  }

  public async getDeployments(
    options?: DeploymentsApiOptions,
  ): Promise<Deployment[]> {
    const { start, end, entityRefs } = options ?? {};
    const url = new URL(await this.discoveryApi.getBaseUrl('deployments'));
    if (start) {
      url.searchParams.set('start', start.toISOString());
    }
    if (end) {
      url.searchParams.set('end', end.toISOString());
    }
    if (entityRefs) {
      for (const ref of entityRefs) {
        url.searchParams.append('entityRef', stringifyEntityRef(ref));
      }
    }
    const response = await this.fetchApi.fetch(url.toString());
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return (await response.json()) as Deployment[];
  }
}
